import clsx from "clsx";
import { ChangeEvent, FC, useState, useEffect } from "react";
import { PulseLoader } from "react-spinners";
import { ArrowSmallDownIcon } from "../../../assets";
import {
  Button,
  CandidateItem,
  CheckBox,
  JobPostingItem,
  PageItem,
  RequestItem,
  SearchInput,
} from "../../../components";
import { ICandidate } from "../../../models/ICandidate";
import { getCandidates } from "../../../services/candidate.service";
import styles from "./styles.module.scss";
import PaginationButtons from "../../../components/PaginationButtons";
const limit = 20;
const Candidates: FC = (): JSX.Element => {
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [candidates, setCandidates] = useState<ICandidate[]>([]);
  const [sort, setSort] = useState<number>(-1);

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onGetCandidates = async (
    page: number = 1,
    limit: number,
    search: string = ""
  ) => {
    try {
      setIsLoading(true);

      const { data } = await getCandidates(page, limit, search, sort);
      if (data?.success) {
        setPagesCount(Math.ceil(data?.count / limit));
        setCandidates(data?.candidates);
        setPage(page);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (search) {
        onGetCandidates(1, limit, search);
      }
    }, 400);

    return () => clearTimeout(timeout);
  }, [search, sort]);

  useEffect(() => {
    if (!search) {
      onGetCandidates(1, limit);
    }
  }, [search, sort]);

  return (
    <>
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <h4 className={styles.title}>All Candidates</h4>
        </header>
        <section className={styles.contentContainer}>
          <div className={styles.searchContainer}>
            <SearchInput
              placeholder="Search"
              value={search}
              onChange={onChangeSearch}
            />
          </div>
          <div className={styles.sectionHeader}>
            <CheckBox isChecked={false} setIsChecked={() => {}} />
            <div className={styles.jobBlock}>
              <p>Candidate</p> <ArrowSmallDownIcon />
            </div>
            <div className={styles.companyBlock}>
              <p>Location</p> <ArrowSmallDownIcon />
            </div>

            <div
              onClick={() => setSort((prev) => (prev === 1 ? -1 : 1))}
              className={clsx(styles.dateBlock, {
                [styles.dateBlockActive]: sort === 1,
              })}
            >
              <p>Registration date</p> <ArrowSmallDownIcon />
            </div>
          </div>
          <div className={styles.reportsContainer}>
            {isLoading && (
              <div className={styles.loaderWrapper}>
                <PulseLoader color={"#7D4AFB"} />
              </div>
            )}
            {!isLoading &&
              candidates.map((item, index) => {
                return <CandidateItem key={item.id} item={item} />;
              })}
          </div>
          <PaginationButtons
            pagesCount={pagesCount}
            page={page}
            onPress={(index) => onGetCandidates(index, limit, search)}
          />
        </section>
      </div>
    </>
  );
};

export default Candidates;
